export default {"src":"/_next/static/media/checkmark-icon-4.b2fcbc05.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};